import { storeEvent, sentPromises } from './store'
import { sendPendingEventsLogic } from './processLogic'

export const addEvent = async (userId, stepId, eventId, eventValue) => {
  await storeEvent(userId, {
    StepId: stepId,
    EventId: eventId,
    EventValue: eventValue,
    InsertDateTime: new Date().toISOString(),
    ResultCode: 0
  })
}

export const sendPendingEvents = async (userId) => {
  var promise = sendPendingEventsLogic(userId)
  sentPromises.push(promise)
  return await promise
}

export const checkAllEventAreSent = async (userId) => {
  // If some events are beeing processed wait for it to finish.
  if (sentPromises.length > 0) {
    await Promise.all(sentPromises)
  }
  // If missing to send some events run a new batch and send it.
  await sendPendingEvents(userId)
  // clearStorage(userId)
  return true
}
